$(() => {
    $('.js_component_filter').on('submit', function (e) {
        $(this)
            .find('input[name], select[name]')
            .filter(function () {
                return !this.value;
            })
            .prop('name', '');
    });
});

/**
 * Dynamic filters
 */

$(() => {
    const $filterType = $('.js_component_filter_item_type .js_component_select_multiple');
    const $filterButtons = $('.js_component_filter .filter-buttons');
    const dynamicFields = JSON.parse($('.js_component_dynamic_filter_options').text() || '{}');
    const dynamicValues = JSON.parse($('.js_component_dynamic_filter_values').text() || '{}');
    
    $filterType.on('change', () => updateFilters());

    const updateFilters = () => {
        /**
         * Show/hide dynamic filters by "log type"
         */
        const value = $filterType.val() || [];

        $('.js_component_filter_item').each((index, item) => {
            const $input = $(item).find('input');
            dynamicValues[$(item).data('filter-key')] = $input.val();
        });

        $('.js_component_filter_item').remove();

        Object.entries(dynamicFields).forEach(([key, field]) => {
            if (_.intersection(value, field.types).length === 0) {
                return;
            }

            const $item = $('<div>', {
                class: 'js_component_filter_item col-sm-3 mb-2',
            }).data('filter-key', key);

            $('<label>', {
                class: 'mb-1 mt-2 text-muted',
                text: field.label,
            }).appendTo($item);

            $('<input>', {
                name: `dynamic[${key}]`,
                type: 'text',
                class: 'form-control',
                value: dynamicValues[key] || '',
            }).appendTo($item);

            $item.insertBefore($filterButtons);
        });
    };

    updateFilters();
});
